export default __webpack_public_path__ + "static/media/mediawiki.1dc2d444.svg";